@for (menuItemGroup of menuItemGroups; track $index; let groupIndex = $index) {
  <ui-kit-menu-item-group
    class="sidebar-menu"
    [menuItemGroupLabel]="menuItemGroup.label"
  >
    @for (item of menuItemGroup.menuItems; track $index) {
      @if (item.menuItems?.length) {
        @let expandableItemKey = getExpandableItemKey(groupIndex, $index);
        <ui-kit-expandable-menu-item
          class="expandable-menu-item"
          [icon]="item.icon"
          [activeMatchOptions]="menuItemGroupOptions"
          [menuItems]="item.menuItems"
          [expand]="isItemExpanded(expandableItemKey)"
          (expandChange)="onExpandableItemChange(expandableItemKey, $event)"
        >
          @if (isCollapsed()) {
            @if (!item.icon && item.shortName) {
              <ui-kit-menu-item-label>{{ item.shortName }}</ui-kit-menu-item-label>
            }
          } @else {
            <ui-kit-menu-item-label>{{ item.name }}</ui-kit-menu-item-label>
          }

          @for (item of item.menuItems; track $index) {
            <ui-kit-menu-item class="menu-item" [icon]="item.icon" [link]="item.routerLink ?? ''">
              <span class="menu-item-text">
                @if (isCollapsed()) {
                  @if (!item.icon) {
                    {{ item.shortName ?? item.name }}
                  }
                } @else {
                  {{ item.name }}
                }
              </span>
            </ui-kit-menu-item>
          }
        </ui-kit-expandable-menu-item>
      } @else {
        <ui-kit-menu-item
          [icon]="item.icon"
          [link]="item.routerLink ?? ''"
          [activeMatchOptions]="item.hasSubNavs ? menuItemGroupOptions : undefined"
          [gaEvent]="item.gaEvent"
        >
          @if (isCollapsed()) {
            @if (!item.icon && item.shortName) {
              {{ item.shortName }}
            }
          } @else {
            {{ item.name }}
          }
        </ui-kit-menu-item>
      }
    }

  </ui-kit-menu-item-group>
}
